if (!customElements.get('contact-popup')) {
  customElements.define(
    'contact-popup',
    class ContactPopup extends HTMLElement {
      connectedCallback() {
        this.key = this.dataset.key || '7sea-contact-popup';
        this.attemptKey = this.key + '-attempt';
        this.shown = false;
        this.timeReady = false;

        this.initChips();
        this.initTracking();

        this.querySelectorAll('[data-close], [data-scrim]').forEach((el) =>
          el.addEventListener('click', () => this.close(true))
        );
        this.onKey = (event) => {
          if (event.key === 'Escape') this.close(true);
        };

        // A submitted form reloads the page. Reopen so the success message is seen,
        // then never show it to this visitor again.
        if (this.hasAttribute('data-posted')) {
          this.remember('done');
          this.clearAttempts();
          this.open();
          return;
        }

        if (this.blocked()) return;

        // Each dismiss moves the visitor one step down the delay ladder. The step
        // survives navigation, so the next page picks up where the last one left off.
        this.delays = (this.dataset.delays || '')
          .split(',')
          .map((value) => parseInt(value, 10))
          .filter((value) => !isNaN(value) && value >= 0);
        if (!this.delays.length) this.delays = [90];

        this.attempt = this.readAttempts();
        if (this.attempt >= this.delays.length) return;

        this.watch(this.delays[this.attempt]);
      }

      readAttempts() {
        try {
          return parseInt(window.sessionStorage.getItem(this.attemptKey), 10) || 0;
        } catch (error) {
          return 0;
        }
      }

      saveAttempts(count) {
        try {
          window.sessionStorage.setItem(this.attemptKey, String(count));
        } catch (error) {
          // Private mode: the ladder restarts on the next page, which is acceptable.
        }
      }

      clearAttempts() {
        try {
          window.sessionStorage.removeItem(this.attemptKey);
        } catch (error) {
          // Nothing to do.
        }
      }

      blocked() {
        try {
          const raw = window.localStorage.getItem(this.key);
          if (!raw) return false;
          const saved = JSON.parse(raw);
          if (saved.state === 'done') return true;
          return Date.now() < saved.until;
        } catch (error) {
          return false;
        }
      }

      remember(state) {
        const days = state === 'done' ? 3650 : parseInt(this.dataset.dismissDays, 10) || 30;
        try {
          window.localStorage.setItem(
            this.key,
            JSON.stringify({ state: state, until: Date.now() + days * 86400000 })
          );
        } catch (error) {
          // Private mode or storage full: the popup simply shows again next visit.
        }
      }

      watch(seconds) {
        this.threshold = (parseInt(this.dataset.scroll, 10) || 0) / 100;

        window.setTimeout(() => {
          this.timeReady = true;
          this.check();
        }, seconds * 1000);

        this.onScroll = () => this.check();
        window.addEventListener('scroll', this.onScroll, { passive: true });
      }

      check() {
        if (this.shown || !this.timeReady) return;
        const max = document.documentElement.scrollHeight - window.innerHeight;
        const pct = max > 0 ? window.scrollY / max : 1;
        if (pct >= this.threshold) this.open();
      }

      open() {
        if (this.shown) return;
        this.shown = true;
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
        this.setAttribute('data-open', '');
        document.addEventListener('keydown', this.onKey);
        const first = this.querySelector('input, select, textarea, button');
        if (first) window.setTimeout(() => first.focus({ preventScroll: true }), 340);
      }

      close(save) {
        this.removeAttribute('data-open');
        document.removeEventListener('keydown', this.onKey);
        if (!save || this.hasAttribute('data-posted')) return;

        const next = this.attempt + 1;
        this.saveAttempts(next);
        // Out of attempts: stop asking for the configured number of days.
        if (next >= this.delays.length) this.remember('dismissed');
      }

      initTracking() {
        const ref = this.querySelector('[data-popup-ref]');
        const utm = this.querySelector('[data-popup-utm]');
        if (ref) {
          let value = 'Direct or unknown';
          if (document.referrer) {
            try {
              const from = new URL(document.referrer);
              value = from.host === location.host ? from.pathname : document.referrer;
            } catch (error) {
              value = document.referrer;
            }
          }
          ref.value = value + ' | shown on ' + location.pathname;
        }
        if (utm) {
          const params = new URLSearchParams(location.search);
          const parts = [];
          params.forEach((paramValue, key) => {
            if (key.indexOf('utm_') === 0 || key === 'ref' || key === 'gclid' || key === 'fbclid') {
              parts.push(key + '=' + paramValue);
            }
          });
          utm.value = parts.join(', ');
        }
      }

      initChips() {
        const boxes = this.querySelectorAll('.contact-popup__chip-input');
        const hidden = this.querySelector('[data-popup-services]');
        if (!boxes.length || !hidden) return;
        const sync = () => {
          const picked = [];
          boxes.forEach((box) => {
            if (box.checked) picked.push(box.value);
          });
          hidden.value = picked.join(', ');
        };
        boxes.forEach((box) => box.addEventListener('change', sync));
        sync();

        const form = hidden.closest('form');
        const error = this.querySelector('[data-chips-error]');
        if (!form) return;
        form.addEventListener('submit', (event) => {
          if (hidden.value === '') {
            event.preventDefault();
            if (error) {
              error.hidden = false;
              error.scrollIntoView({ block: 'center', behavior: 'smooth' });
            }
          }
        });
        boxes.forEach((box) =>
          box.addEventListener('change', () => {
            if (error && hidden.value !== '') error.hidden = true;
          })
        );
      }
    }
  );
}